/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BoldInputs */

const en_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold`)
};

const fr_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gras`)
};

const de_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutlich`)
};

const it_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grassetto`)
};

const ru_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смелый`)
};

const es_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrevido`)
};

const zh_cn2_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大胆的`)
};

const ja_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大胆な`)
};

const hi_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बोल्ड`)
};

const pt_pt2_bold = /** @type {(inputs: BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audacioso`)
};

/**
* | output |
* | --- |
* | "Bold" |
*
* @param {BoldInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bold = /** @type {((inputs?: BoldInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BoldInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_bold(inputs)
	if (locale === "de") return de_bold(inputs)
	if (locale === "it") return it_bold(inputs)
	if (locale === "ru") return ru_bold(inputs)
	if (locale === "es") return es_bold(inputs)
	if (locale === "zh-CN") return zh_cn2_bold(inputs)
	if (locale === "ja") return ja_bold(inputs)
	if (locale === "hi") return hi_bold(inputs)
	if (locale === "pt-PT") return pt_pt2_bold(inputs)
	return en_bold(inputs)
});